import useSmartBrowserPresenter from '@Components/NavigationContentDrawer/Panels/PrimaryNavigationColumn/SmartBrowser/SmartBrowser.presenter';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';
import type { LayoutChangeEvent } from 'react-native';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';

import OwnableTheme from '../../../assets/OwnableTheme';
import TextInput from '../../Common/TextInput';
import {
  StyledButtonContainer,
  StyledFormContainer,
  StyledSmartHeaderContainer,
} from './SmartBrowserFormModal.common';

type Props = {
  onEmailTextInputLayout?: (event: LayoutChangeEvent) => void;
  onEmailTextInputFocus?: () => void;
  onPasswordTextInputLayout?: (event: LayoutChangeEvent) => void;
  onPasswordTextInputFocus?: () => void;
  onConfirmPasswordTextInputLayout?: (event: LayoutChangeEvent) => void;
  onConfirmPasswordTextInputFocus?: () => void;
};

const SmartBrowserFormModalContentSignUp: FC<Props> = ({
  onEmailTextInputLayout,
  onEmailTextInputFocus,
  onPasswordTextInputLayout,
  onPasswordTextInputFocus,
  onConfirmPasswordTextInputLayout,
  onConfirmPasswordTextInputFocus,
}) => {
  const {
    setEmailAddress,
    setPassword,
    setConfirmPassword,
    emailAddress,
    password,
    confirmPassword,
    handleSignupSubmit,
    authError,
  } = useSmartBrowserPresenter();
  return (
    <>
      <StyledSmartHeaderContainer>
        <Text style={styles.header}>
          Sign up to view all your shopping details
        </Text>
      </StyledSmartHeaderContainer>
      <StyledFormContainer>
        <TextInput
          onLayout={onEmailTextInputLayout}
          onFocus={onEmailTextInputFocus}
          gutterBottom={16}
          fontSizePx={20}
          placeholder='Email'
          value={emailAddress}
          bgColor='mercury'
          onChange={(text) => {
            setEmailAddress(text);
          }}
          textAlign='center'
          color={OwnableTheme.colors.black}
        />
        <TextInput
          onLayout={onPasswordTextInputLayout}
          onFocus={onPasswordTextInputFocus}
          gutterBottom={16}
          secureTextEntry
          fontSizePx={20}
          placeholder='Password'
          value={password}
          bgColor='mercury'
          onChange={(text) => {
            setPassword(text);
          }}
          textAlign='center'
          color={OwnableTheme.colors.black}
        />
        <TextInput
          onLayout={onConfirmPasswordTextInputLayout}
          onFocus={onConfirmPasswordTextInputFocus}
          gutterBottom={16}
          secureTextEntry
          fontSizePx={20}
          placeholder='Confirm Password'
          value={confirmPassword}
          bgColor='mercury'
          onChange={(text) => {
            setConfirmPassword(text);
          }}
          textAlign='center'
          color={OwnableTheme.colors.black}
        />
        {/* @ts-expect-error */}
        <Text size='xxs' align='center' color={OwnableTheme.colors.errorRed}>
          {authError ? authError : ' '}
        </Text>
        <TouchableOpacity onPress={handleSignupSubmit}>
          <StyledButtonContainer>
            <Text style={styles.buttonText}>Create account</Text>
          </StyledButtonContainer>
        </TouchableOpacity>
      </StyledFormContainer>
    </>
  );
};

export default observer(SmartBrowserFormModalContentSignUp);

const styles = StyleSheet.create({
  header: {
    fontFamily: OwnableTheme.fonts.gilroy.bold,
    color: OwnableTheme.colors.black,
    fontSize: 24,
    textAlign: 'center',
    paddingHorizontal: 20,
  },
  buttonText: {
    color: OwnableTheme.colors.white,
    fontSize: 20,
  },
});
